import React from "react";
import { Modal } from "../../../components/ui";
import { Wallet, BarChart3 } from "lucide-react";

export const ViewAccount = ({ isOpen, onClose, account }) => {
  if (!account) return null;

  const displayName = account.customerName || `${account.firstName || ""} ${account.lastName || ""}`.trim() || "Account";
  const customId = account.customId || "—";
  
  const budget = Number(account.budget) || Number(account.projectValue) || 0;
  const totalReceived = Number(account.totalReceived) || 0;
  const otherExpenses = Number(account.otherExpenses) || 0;
  const materialExpenses = Number(account.materialExpenses) || 0;
  const totalExpenses = otherExpenses + materialExpenses;
  const balanceDue = Number(account.balance) || 0;
  const budgetLeft = budget - totalExpenses;
  
  const fmt = (v) => new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? 'col-span-2' : ''}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`ACCOUNT DETAILS: #${customId.toUpperCase()}`} size="max-w-lg">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <Card label="Verve ID" v={customId.toUpperCase()} />
          <Card label="Project Status" v={(account.leadStatus || account.status || 'New').replace('_', ' ').toUpperCase()} />
          
          <Card label="Customer Name" v={displayName} />
          <Card label="Owner Approval" v={account.paymentStatus || "Pending"} />
          
          <Card label="Phone Number" v={account.phoneNumber || account.phone || "—"} />
          <Card label="Email" v={account.email || "—"} />

          <Card label="Address" v={(() => {
            const parts = [
              account.addressLine1 || account.address1,
              account.addressLine2 || account.address2,
              account.city,
              account.district,
              account.state,
              account.pincode
            ].filter(Boolean);
            return parts.length > 0 ? parts.join(", ") : '—';
          })()} fullWidth />

          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <Wallet size={14} /> Financial Overview
            </label>
          </div>
          
          <Card label="Project Value" v={`₹${fmt(budget)}`} />
          <Card label="Total Received" v={`₹${fmt(totalReceived)}`} />
          <Card label="Balance Due" v={`₹${fmt(balanceDue)}`} />

          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <BarChart3 size={14} /> Expenses Breakdown
            </label>
          </div>
          
          <Card label="Project Expenses" v={`₹${fmt(otherExpenses)}`} />
          <Card label="Material Expenses" v={`₹${fmt(materialExpenses)}`} />
        </div>
      </div>
    </Modal>
  );
};
